import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { GetEmbodimentKeywordsApi, type ApiGetEmbodimentKeywordsResponse } from '@/infrastructure/api-functions/core-drafting-api/get-embodiment-keywords-api';
import { CurrentTaskService } from '@/services/current-task/current-task-service';
import type { KeywordsItem } from '../../types';
import type { EmbodimentFeatureKeywordsService } from '../embodiment-feature-keywords-service';

const FIELD_SORT: Array<keyof ApiGetEmbodimentKeywordsResponse> = ['hypernym', 'parallel', 'hyponym'];

@injectable()
export class EmbodimentFeatureKeywordsServiceImpl implements EmbodimentFeatureKeywordsService {
    constructor(
        @inject(GetEmbodimentKeywordsApi)
        private _getEmbodimentKeywordsApi: GetEmbodimentKeywordsApi,
        @inject(CurrentTaskService)
        private _currentTaskService: CurrentTaskService,
    ) {}

    async fetchKeywords(num: string, concept: string): Promise<KeywordsItem[]> {
        const resultList: KeywordsItem[] = [];

        try {
            const result = await this._getEmbodimentKeywordsApi.getEmbodimentKeywords({
                task_id: this._currentTaskService.taskId,
                concept,
                num,
            });

            FIELD_SORT.forEach(field => {
                if (!result[field]?.length) return;

                resultList.push({
                    type: field,
                    value: [...result[field]],
                });
            });
        } catch (error) {
            console.log(error);
        }

        return resultList;
    }
}
